import axiosInstance from '../api';

// ── Org side: /api/engagements ──
export const getCatalog = () => axiosInstance.get('/engagements/catalog').then((r) => r.data || []);
export const getLegalProfile = () => axiosInstance.get('/engagements/legal-profile').then((r) => r.data);
export const saveLegalProfile = (body) => axiosInstance.put('/engagements/legal-profile', body).then((r) => r.data);
export const listEngagements = () => axiosInstance.get('/engagements').then((r) => r.data || []);
export const getEngagement = (id) => axiosInstance.get(`/engagements/${id}`).then((r) => r.data);
export const requestEngagement = (body) => axiosInstance.post('/engagements', body).then((r) => r.data);
export const updateIntake = (id, body) => axiosInstance.put(`/engagements/${id}/intake`, body).then((r) => r.data);
export const cancelEngagement = (id, reason) => axiosInstance.post(`/engagements/${id}/cancel`, { reason }).then((r) => r.data);
export const getTimeline = (id) => axiosInstance.get(`/engagements/${id}/timeline`).then((r) => r.data || []);
export const getPendingSummary = () => axiosInstance.get('/engagements/pending-summary').then((r) => r.data);
export const fetchDocumentBlob = (id, docId) =>
  axiosInstance.get(`/engagements/${id}/documents/${docId}/content`, { responseType: 'blob' }).then((r) => r.data);
export const signDocument = (id, docId, body) =>
  axiosInstance.post(`/engagements/${id}/documents/${docId}/sign`, body).then((r) => r.data);
export const declineDocument = (id, docId, reason) =>
  axiosInstance.post(`/engagements/${id}/documents/${docId}/decline`, { reason }).then((r) => r.data);
export const fetchExecutedBlob = (id, docId) =>
  axiosInstance.get(`/engagements/${id}/documents/${docId}/executed.pdf`, { responseType: 'blob' }).then((r) => r.data);
export const fetchCertificateBlob = (id, docId) =>
  axiosInstance.get(`/engagements/${id}/documents/${docId}/certificate.pdf`, { responseType: 'blob' }).then((r) => r.data);

// Scope & Boundary (existing API) — used to import assets into the intake.
export const listScopes = () => axiosInstance.get('/iasm/scope/scopes').then((r) => r.data || []);
export const listScopeMembers = (scopeId) => axiosInstance.get(`/iasm/scope/scopes/${scopeId}/members`).then((r) => r.data || []);

// ── Platform admin: /api/admin/engagements ──
export const adminListEngagements = (params) => axiosInstance.get('/admin/engagements', { params }).then((r) => r.data);
export const adminStats = () => axiosInstance.get('/admin/engagements/stats').then((r) => r.data);
export const adminGetEngagement = (id) => axiosInstance.get(`/admin/engagements/${id}`).then((r) => r.data);
export const adminTimeline = (id) => axiosInstance.get(`/admin/engagements/${id}/timeline`).then((r) => r.data || []);
export const adminSaveTerms = (id, terms) => axiosInstance.put(`/admin/engagements/${id}/terms`, terms).then((r) => r.data);
export const adminIssue = (id) => axiosInstance.post(`/admin/engagements/${id}/issue`).then((r) => r.data);
export const adminReissue = (id, docId, note) => axiosInstance.post(`/admin/engagements/${id}/documents/${docId}/reissue`, { note }).then((r) => r.data);
export const adminCountersign = (id, docId, body) => axiosInstance.post(`/admin/engagements/${id}/documents/${docId}/countersign`, body).then((r) => r.data);
export const adminCountersignAll = (id, body) => axiosInstance.post(`/admin/engagements/${id}/countersign-all`, body).then((r) => r.data);
export const adminActivate = (id, note) => axiosInstance.post(`/admin/engagements/${id}/activate`, { note }).then((r) => r.data);
export const adminSuspend = (id, note) => axiosInstance.post(`/admin/engagements/${id}/suspend`, { note }).then((r) => r.data);
export const adminResume = (id, note) => axiosInstance.post(`/admin/engagements/${id}/resume`, { note }).then((r) => r.data);
export const adminComplete = (id, note) => axiosInstance.post(`/admin/engagements/${id}/complete`, { note }).then((r) => r.data);
export const adminCancel = (id, note) => axiosInstance.post(`/admin/engagements/${id}/cancel`, { note }).then((r) => r.data);
export const adminNote = (id, note) => axiosInstance.post(`/admin/engagements/${id}/note`, { note }).then((r) => r.data || []);
export const adminDocumentBlob = (id, docId) =>
  axiosInstance.get(`/admin/engagements/${id}/documents/${docId}/content`, { responseType: 'blob' }).then((r) => r.data);
export const adminCertificateBlob = (id, docId) =>
  axiosInstance.get(`/admin/engagements/${id}/documents/${docId}/certificate.pdf`, { responseType: 'blob' }).then((r) => r.data);
export const adminPreviewHtml = (id, templateId) =>
  axiosInstance.get(`/admin/engagements/${id}/preview/${templateId}`, { responseType: 'text' }).then((r) => r.data);
export const adminIntegrity = (orgId) => axiosInstance.get('/admin/engagements/integrity', { params: { orgId } }).then((r) => r.data);

// ── Platform admin: /api/admin/agreement-templates ──
export const listTemplates = () => axiosInstance.get('/admin/agreement-templates').then((r) => r.data || []);
export const listServiceTypes = () => axiosInstance.get('/admin/agreement-templates/service-types').then((r) => r.data || []);
export const createTemplate = (body) => axiosInstance.post('/admin/agreement-templates', body).then((r) => r.data);
export const updateTemplate = (id, body) => axiosInstance.put(`/admin/agreement-templates/${id}`, body).then((r) => r.data);
export const getTemplateVersion = (id, vid) => axiosInstance.get(`/admin/agreement-templates/${id}/versions/${vid}`).then((r) => r.data);
export const createTemplateVersion = (id, body) => axiosInstance.post(`/admin/agreement-templates/${id}/versions`, body).then((r) => r.data);
export const updateTemplateVersion = (id, vid, body) => axiosInstance.put(`/admin/agreement-templates/${id}/versions/${vid}`, body).then((r) => r.data);
export const publishTemplateVersion = (id, vid) => axiosInstance.post(`/admin/agreement-templates/${id}/versions/${vid}/publish`).then((r) => r.data);
export const templatePreviewBlob = (id, vid) =>
  axiosInstance.get(`/admin/agreement-templates/${id}/versions/${vid}/preview.pdf`, { responseType: 'blob' }).then((r) => r.data);
export const getRequirements = () => axiosInstance.get('/admin/agreement-templates/requirements').then((r) => r.data || []);
export const saveRequirements = (rows) => axiosInstance.put('/admin/agreement-templates/requirements', rows).then((r) => r.data || []);

// ── helpers ──
export const openPdfBlob = (blob) => {
  const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
  window.open(url, '_blank', 'noopener');
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
};

export const downloadBlob = (blob, fileName) => {
  const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 10000);
};

export const fmtDateTime = (s) => (s && s !== 'null' ? String(s).replace('T', ' ').slice(0, 16) : '—');

export const STATUS_LABELS = {
  REQUESTED: 'Requested',
  ISSUED: 'Documents issued',
  AWAITING_COUNTERSIGN: 'Awaiting Cataam countersignature',
  ACTIVE: 'Active',
  ON_HOLD: 'On hold',
  SUSPENDED: 'Suspended',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
};

export const DOC_STATUS_LABELS = {
  PENDING: 'Awaiting your signature',
  VIEWED: 'Viewed — awaiting your signature',
  CLIENT_SIGNED: 'Signed — awaiting Cataam',
  SIGNED: 'Fully executed',
  DECLINED: 'Declined',
  SUPERSEDED: 'Superseded',
  EXPIRED: 'Expired',
};

export const apiError = (e, fallback) =>
  (e && e.response && e.response.data && (e.response.data.message || e.response.data.error)) || fallback;
